import { render, staticRenderFns } from "./cheatsheet.vue?vue&type=template&id=0c86cee4&scoped=true"
import script from "./cheatsheet.vue?vue&type=script&lang=js"
export * from "./cheatsheet.vue?vue&type=script&lang=js"
import style0 from "./cheatsheet.vue?vue&type=style&index=0&id=0c86cee4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c86cee4",
  null
  
)

export default component.exports